@defer (when isSinglePageMode){
  <db-single-page-builder [uniqueId]="uniqueId" [website]="website">
  </db-single-page-builder>
}

@if(!isSinglePageMode){
  @if (isMobile && popupMode) {
    <div class="db-main-header-content">
      <img [src]="logo" alt="logo" />
      <div class="db-header-back-button" (click)="headerBack()"
           *ngIf="![builderStep.SHOW_FINALIZE].includes(builderHistoryService.builderStep|async)">
        <i class="db-icon db-icon-ds-arrow-small"></i>
        <span>back</span>
      </div>
    </div>
  }

  @if ([builderStep.CHOOSE_BUSINESS_TYPE, builderStep.FILL_COMPANY_INFO, builderStep.PRODUCT_TYPE, builderStep.SHOW_FINALIZE,
    builderStep.SHOW_CANVAS, builderStep.SHOW_DESIGN, builderStep.SHOW_HERO].includes(builderHistoryService.builderStep|async)) {
    <div  class="builder-wrapper flex-align">
      <div>
        <db-outline-generation
          [fromVibeCoding]="fromVibeCoding"
          [prefilledAiData]="prefilledAiData"
          [prefilledAi]="prefilledAi"
          [isEcommerce]="isEcommerce"
          [domainId]="domainId"
          [uniqueId]="uniqueId"
          [fromInnerAIPage]="fromInnerAIPage"
          [isOnboarding]="isOnboarding"
          (openMagicLink)="openMagicLink=true"
          [popupMode]="popupMode"
          [outline]="outline"
          [isMobile]="isMobile"
          [tourStep]="tourStep"
          [fontStyles]="fontStyles"
          [website]="website"
          (checkSectionTitles)="checkSectionTitles()"
          (onGenerate)="generateWebsite()"
        ></db-outline-generation>
      </div>
    </div>
  }

<!--
  @if(((builderHistoryService.builderStep|async) === builderStep.SHOW_CANVAS) && isMobile) {
    <div *ngIf="!user">
      <db-sitemap-mobile-dialog
        [pagesLoaded]="builderInteractionsService.secondaryPagesLoaded|async"
        (startGeneration)="this.generateWebsite()"
        [generationStarted]="generationStarted"
        [user]="user"
        [(openMagicLink)]="openMagicLink">
      </db-sitemap-mobile-dialog>
    </div>
  }
-->

  <div *ngFor="let font of fontStyles; let i = index"
       [style.visibility]="'hidden'">
    <div [innerHTML]="font"></div>
  </div>
}

